/**
 * Espejo client-side de `slugifyTagKey` en server/utils/tagHelpers.js.
 * El backend lo usa para transformar tagKey → field name (ej: "PU" → "tag_pu").
 * Lo replicamos en el front porque el modo Preview de DataTable no pasa por
 * el backend y necesita el mismo slug para hacer match con los datos.
 */
export function slugifyTagKey(value: unknown): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'tag';
}
